import React, { useState } from "react";
import { useQuery, gql, useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";
//import { parseShowDate, parseShowTime } from "../libraries/time.jsx";
//import showPlaceholder from "../img/show-placeholder.jpg";
import { XIcon } from "@heroicons/react/solid";
import { BadgeCheckIcon } from "@heroicons/react/solid";

const TOGGLE_ACTIVE_VENUE_MUTATION = gql`
  mutation toggleActiveVenueMutation($id: ID!, $active: Boolean!) {
    updateVenue(id: $id, data: { active: $active }) {
      _id
      name
      active
    }
  }
`;

const VenueClipboard = (venueId) => {
  const [copied, setCopied] = useState(false);
  const handleLinkCopy = (venueInput) => {
    navigator.clipboard.writeText(`/portal/events/${venueInput}`);
  };
  return (
    <div
      className={`flex py-2 underline space-x-2 cursor-pointer hover:text-blue-500 ${
        copied ? "animate-pulse text-green-500" : ""
      }`}
      onClick={() => {
        handleLinkCopy(venueId.venueId);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 1500);
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        />
      </svg>
      {copied ? <span>link copied</span> : <span>copy event portal link</span>}
    </div>
  );
};

export const Admin = (props) => {
  const history = useHistory();
  //let { path, url } = useRouteMatch();

  const [toggleVenueStatus] = useMutation(TOGGLE_ACTIVE_VENUE_MUTATION, {
    onCompleted: () => {
      console.log("Status toggled");
    },
  });

  const GET_VENUES = gql`
    {
      getVenues {
        data {
          _id
          name
          address
          thumbnail
          lat
          long
          active
          shows {
            data {
              _id
              start_time
              end_time
            }
          }
        }
      }
    }
  `;
  const { data, loading, error } = useQuery(GET_VENUES);

  if (loading) {
    return "Loading...";
  }
  if (error) return `Error! ${error}`;

  return (
    <div className="pt-32 h-screen overflow-y-auto">
      <div className="glass rounded-t-md pt-2 relative">
        <XIcon
          className="absolute w-8 h-8 top-2 right-2 z-10"
          onClick={() => history.goBack()}
        />
        <p className="px-2 pb-4 text-xl">Venues</p>
        <ul className="space-y-3 px-2">
          {data.getVenues.data.map((venue) => {
            let VenueStatus = () => {
              return venue.active ? (
                <div className="flex items-center">
                  <button
                    onClick={() =>
                      toggleVenueStatus({
                        variables: { id: venue._id, active: !venue.active },
                      })
                    }
                    className="mr-4 text-sm"
                  >
                    deactivate
                  </button>
                  <BadgeCheckIcon className="w-8 text-green-500" />
                </div>
              ) : (
                <div className="flex items-center">
                  <button
                    onClick={() =>
                      toggleVenueStatus({
                        variables: { id: venue._id, active: !venue.active },
                      })
                    }
                    className="mr-4 text-sm"
                  >
                    activate
                  </button>
                  <BadgeCheckIcon className="w-8 text-red-500" />
                </div>
              );
            };

            return (
              <li
                className="bg-white shadow overflow-hidden rounded-md flex justify-between items-center px-6 "
                key={venue._id}
              >
                <div className="py-1 pb-4">
                  <p className="line-clamp-1">{venue.name}</p>
                  <p className="line-clamp-1">{venue._id}</p>
                  <p className="line-clamp-1">{venue.activeState}</p>
                  <p className="text-xs text-gray-500 line-clamp-1">
                    {venue.address}
                  </p>
                  <p className="line-clamp-1">
                    {venue.lat} / {venue.long}
                  </p>
                  <VenueClipboard venueId={venue._id} />
                </div>
                <div className="w-1/2 flex justify-between py-1 pb-4">
                  <div
                    className="w-1/2 h-24 rounded-l-md bg-cover bg-center"
                    style={{ backgroundImage: `url(${venue.thumbnail})` }}
                  ></div>
                  <VenueStatus />
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
